import Swiper, {Navigation} from "swiper"
Swiper.use([Navigation])

class ESlider {

  constructor (el) {
    this.el = el
    this.slider = null

    this.init()
  }

  init () {
    this.slider = new Swiper(this.el, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      observer: true,
      watchSlidesVisibility: true,
      navigation: {
        prevEl: '.e-slider__btn--prev',
        nextEl: '.e-slider__btn--next'
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 30
        }
      }
    })
  }

}

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.js-e-slider')

  if (items.length) {
    items.forEach(el => new ESlider(el))
  }
})
